/* eslint-disable react-hooks/exhaustive-deps */
import { ExperimentResults, StimulusData, ViolationLog } from 'types';
const AUDIO_API_URL = process.env.REACT_APP_AUDIO_API_URL!;
const RESULTS_API_URL = process.env.REACT_APP_RESULTS_API_URL!;

interface Props {
	exp_data: ExperimentResults;
	stim_data: StimulusData;
	stim_header: string[];
	stim_list: string;
	experiment_start_time: string;
	experiment_end_time: string;
	experiment_name: string;
	experiment_file_name_column: string;
	violation_logs?: ViolationLog[];
}

class SaveData {
	exp_data: ExperimentResults;
	stim_data: StimulusData;
	stim_header: string[];
	stim_list: string;
	experiment_start_time: string;
	experiment_end_time: string;
	experiment_name: string;
	experiment_file_name_column: string;
	violation_logs?: ViolationLog[];

	constructor(props: Props) {
		this.exp_data = props.exp_data;
		this.stim_data = props.stim_data;
		this.stim_header = props.stim_header;
		this.stim_list = props.stim_list;
		this.experiment_start_time = props.experiment_start_time;
		this.experiment_end_time = props.experiment_end_time;
		this.experiment_name = props.experiment_name;
		this.experiment_file_name_column = props.experiment_file_name_column;
		this.violation_logs = props.violation_logs;
	}

	// Called to format multi-dimensional array into multiple JSON objects
	arrayToJSONObject(arr: any[], header_arr: string[]) {
		//console.log(arr);
		// Getting rid of blank row
		arr.shift();
		const keys = arr[0];

		// vacate keys from main array
		const newArr = arr.slice(1, arr.length);

		const formatted = [];
		const data = newArr;
		const cols = keys;
		const l = cols.length;
		for (let i = 0; i < data.length; i++) {
			const d = data[i];
			const o: any = {};
			for (let j = 0; j < l; j++) o[cols[j]] = d[j];
			formatted.push(o);
		}
		//console.log(formatted);
		return formatted;
	}

	// Sends experiment results, stimulus information, and tester information to server
	async saveToDb(output: object[], experiment_name: string, information: object[]) {
        // --- BULLETPROOF FIX: Grab from localStorage ---
		// Grab the custom violations we caught
        const screenViolations = (window as any).SCREEN_VIOLATIONS || [];
        
        // Merge them with your framework's native violation logs
        const finalViolations = [...(this.violation_logs || []), ...screenViolations];

        const result = {
            resultObj: output,
            experimentName: experiment_name,
            informationArr: information,
            violationLogs: finalViolations
        };

        //console.log("📦 FINAL PAYLOAD LEAVING BROWSER:", result);

        await fetch(RESULTS_API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(result)
        }).catch((error) => {
            window.alert(error);
        });
    }

	async sendAudioFile(file: Blob, pcode: any, exp_name: any, fileNameStr: string) {
		//console.log(fileNameStr);
		const data = new FormData();
		data.append('pCode', pcode);
		data.append('stimlist',this.stim_list);
		data.append('audioFileName', fileNameStr);
		data.append('expName', exp_name);
		data.append('file', file);

		await fetch(AUDIO_API_URL, {
			method: 'post',
			body: data
		}).catch((error) => {
			window.alert(error);
		});
	}

async output_to_db() {
        // To store all audio file
        let audio_result: any[] = [];
        const output: string[][] = [[]];
        const headerArr: any[] = this.stim_header;
        
        const { pcode, blockOrder, blockResults } = this.exp_data;

        // --- NEW: Peek at the first response to see if it's a Bayesian 'custom' run ---
       // --- NEW: Peek at the first valid response to see if it's a Bayesian 'custom' run ---
        let isCustomBayesian = false;
        
        if (this.exp_data.blockResults) {
            // Safely search all blocks to find the first one that actually contains responses
            const firstValidBlock = Object.values(this.exp_data.blockResults).find(
                (block: any) => block && block.responses && block.responses.length > 0
            ) as any;

            // If we found a response, check if it has our Bayesian data attached
            if (firstValidBlock && firstValidBlock.responses[0].t_mean !== null && firstValidBlock.responses[0].t_mean !== undefined) {
                isCustomBayesian = true;
            }
        }

        // Dynamically build the headers
        let extraHeaders = ['response', 'responseTime', 'pcode', 'stimlist'];
        if (isCustomBayesian) {
            extraHeaders = extraHeaders.concat(['t_mean', 't_sd', 's_mean', 's_sd']);
        }
        
        const headerArrConcat = headerArr.concat(extraHeaders);
        output.push(headerArrConcat);
        // -----------------------------------------------------------------------------
        // -----------------------------------------------------------------------------

 // --- CHANGED: Iterate over the actual saved data blocks instead of the CSV's blockOrder ---
        const virtualBlocks = Object.keys(this.exp_data.blockResults || {});
        
        virtualBlocks.forEach((block_number, block_index) => {
            const block = this.exp_data.blockResults[block_number as any];
            
            // Safely skip this block if it was never played/has no data
            if (!block || !block.responses) return;

            // loop through each response
            block.responses.forEach((response, response_index) => {
                const trial_number = `${response.trialNumber}`;
                //console.log(trial_number);
                let stimuli: string[] = [];
                // look for the matching line in the stimuli list

				const fileIndex = this.stim_header.indexOf(this.experiment_file_name_column);
				this.stim_data.forEach((stim_block) => {
					stim_block.forEach((stim) => {
						// if we have a match, save it
						// --- CHANGED: Safely handle Virtual Blocks by checking if the CSV is just one giant block ---
						if ((stim[0] === `${block_number}` || this.stim_data.length === 1) && stim[1] === trial_number) {
							stimuli = stim;
							// When the response type is the audio
							// @ts-ignore
							if (response.answer instanceof Blob) {
								const audio_download_object = document.createElement('a');
								audio_download_object.download = `${pcode}_${block_number}_${trial_number}.ogg`;
								// saveaudioFile(response.answer,block_number,pcode,trial_number)
								const url = URL.createObjectURL(response.answer);
								audio_download_object.href = url;
								audio_download_object.addEventListener('click', (e) => {
									setTimeout(() => URL.revokeObjectURL(audio_download_object.href), 30 * 1000);
								});
								const blobResponse = response.answer as Blob;
								audio_result.push(audio_download_object);
								const fileName = stim[fileIndex];
								//console.log(fileName);
								const fileNameStr = fileName!.substring(0, fileName!.lastIndexOf('.'));
								audio_result.forEach((element) => {
									// this is how it saves audio to disc currently
									const str = element.download as string;
									const splitted = str.split('_');
									// TODO: This could use better error handling
									this.sendAudioFile(blobResponse, splitted[0], this.experiment_name, fileNameStr);
								});
								audio_result = [];
							}
						}
					});
				});
				// add the results and push
                const row: any[] = stimuli;
                let finalObject: any[] = row.concat([
                    response.answer,
                    `${Math.round(response.responseTime)}`,
                    pcode,
                    this.stim_list
                ]);

				// --- NEW: Cast response as 'any' to bypass strict TypeScript rules ---
                const res = response as any;

                if (res.t_mean !== undefined && res.t_mean !== null) {
                    finalObject = finalObject.concat([
                        res.t_mean.toString(),
                        res.t_sd.toString(),
                        res.s_mean.toString(),
                        res.s_sd.toString()
                    ]);
                }
                // --------------------------------------------------------------

                output.push(finalObject);
			});
		});


		// --- NEW: Force the framework to wait  for the mic to finish ---
        //console.log("⏳ HOLDING DATABASE SAVE FOR 500ms  TO CATCH FINAL WORDS...");
        await new Promise(resolve => setTimeout(resolve, 500));

        const information: any[][] = [[]];
        const informationHeader: string[] = ['pcode', 'experimentStartTime', 'experimentEndTime', 'experimentDuration','stimulusList', 'transcription'];
        
        information.push(['pcode', 'experimentStartTime', 'experimentEndTime', 'experimentDuration','stimulusList', 'transcription']);
        
        // --- NEW: Read from the exact same synchronized key ---
        const finalTranscription = localStorage.getItem("QUALTRICS_TRANSCRIPT") || "No transcription recorded";
        //console.log("📦 PACKAGING FOR DATABASE. Found transcription:", finalTranscription);

        information.push([
            pcode,
            this.experiment_start_time,
            this.experiment_end_time,
            `${(this.exp_data.experimentDuration / 60000).toFixed(1)} minutes`,
            this.stim_list,
            finalTranscription 
        ]);

        const JSONResultsarr = this.arrayToJSONObject(output, headerArrConcat);
        const JSONInformationarr = this.arrayToJSONObject(information, informationHeader);
        await this.saveToDb(JSONResultsarr, this.experiment_name, JSONInformationarr);

        return output;
	}
}

export default SaveData;
